import React, { useCallback, useMemo } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ServerSideReactTable from "commons/table/ServerSideReactTable";
import { CreateColumnListForBlacklistedContactsList } from "./CreateColumnListForBlacklistedContactsList";

const DEFAULT_PAGE_SIZE = 15;

const BlacklistedContactsListCommon = (props) => {
  const {
    columnList: columnListProp,
    onActionComplete,
    updateBlacklistedContactsList,
    updateListState,
    data = [],
    pages = 0,
    loading = false,
    totalElements = 0,
    listState = {},
  } = props;

  const columnList = useMemo(
    () =>
      CreateColumnListForBlacklistedContactsList(
        columnListProp,
      true,
        onActionComplete
    ),
    [columnListProp, onActionComplete]
  );

  const fetchData = useCallback(
    ({ filtered = [], page = 0, pageSize = DEFAULT_PAGE_SIZE }) => {
      const activeFilters = filtered.filter((f) => {
      if (typeof f.value === "string") return f.value.trim() !== "";
      if (Array.isArray(f.value)) return f.value.length > 0;
      return f.value != null;
    });

    updateBlacklistedContactsList?.(page, pageSize, activeFilters);
    },
    [updateBlacklistedContactsList]
  );

  const onUpdateTable = useCallback(
    (filtered, _sorted, pageSize, page) => {
      fetchData({ filtered, pageSize, page });

      updateListState?.({
      page,
      pageSize,
      filtered,
    });
    },
    [fetchData, updateListState]
  );

    const {
      page = 0,
      pageSize = DEFAULT_PAGE_SIZE,
      filtered = [],
    } = listState;

    return (
      <Row>
        <Col md={12}>
          <ServerSideReactTable
            columnDefination={columnList}
            data={data}
            currentPage={page}
            sorted={[]}
            filters={filtered}
            totalPages={pages}
            totalRecords={totalElements === "loading" ? 0 : totalElements}
            loading={loading}
            pageSizeOptions={[5, 10, 15, 20, 30, 50]}
            defaultPageSize={pageSize}
            onUpdateTableData={onUpdateTable}
          />
        </Col>
      </Row>
    );
};

export default BlacklistedContactsListCommon;
